module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('div', {
    staticClass: "py-4"
  }, [_c('div', {
    staticClass: "mb-4 display-1"
  }, [_vm._v("Stanje računa")]), _vm._v(" "), _c('div', {
    staticClass: "my-2 title"
  }, [_vm._v("Stanje računa "), _c('strong', [_vm._v(_vm._s(_vm.user.balance) + " RSD")])]), _vm._v(" "), _c('div', {
    staticClass: "my-2 title"
  }, [_vm._v("Dozvoljeni minus "), _c('strong', [_vm._v(_vm._s(_vm.user.credit) + " RSD")])])]), _vm._v(" "), _c('div', {
    staticClass: "py-4"
  }, [_c('div', {
    staticClass: "mt-4 display-1"
  }, [_vm._v("Istorija transakcija")]), _vm._v(" "), _c('table', [_vm._l((_vm.transactions), function(transaction, i) {
    return [(i === 0 || _vm.formatDate(_vm.transactions[i - 1].created) !== _vm.formatDate(transaction.created)) ? _c('th', [_c('td', {
      staticClass: "pt-4",
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v(_vm._s(_vm.formatDate(transaction.created)))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "px-2"
    }, [_vm._v(_vm._s(_vm.formatTime(transaction.created)))]), _vm._v(" "), _c('td', {
      staticClass: "px-2 align-right"
    }, [_vm._v(_vm._s(transaction.value) + " RSD")]), _vm._v(" "), _c('td', {
      staticClass: "px-2"
    }, [(transaction.delivery_id) ? _c('router-link', {
      attrs: {
        "to": '/delivery/' + transaction.delivery_id
      }
    }, [_vm._v("dostava")]) : _vm._e()], 1)])]
  })], 2)])])], 1)], 1)
},staticRenderFns: []}